import React from 'react';

const DealProgressIndicator = ({ status }) => {
  if (status === 'cancelled') {
    return (
      <div className="deal-progress-cancelled">
        <div className="deal-progress-cancelled-icon">&times;</div>
        <span>Cancelled</span>
      </div>
    );
  }

  const steps = [
    { key: 'document_creation', label: 'Document Creation' },
    { key: 'tracking', label: 'Tracking' },
    { key: 'closed', label: 'Closed' }
  ];

  const currentStepIndex = steps.findIndex(step => step.key === status);

  return (
    <div className="deal-progress-container">
      {steps.map((step, index) => (
        <React.Fragment key={step.key}>
          <div className="progress-step">
            <div className={`step-circle ${index <= currentStepIndex ? 'active' : ''} ${index < currentStepIndex ? 'completed' : ''}`}>
              {index < currentStepIndex ? '✓' : index + 1}
            </div>
            <span className="step-label">{step.label}</span>
          </div>
          {index < steps.length - 1 && (
            <div className={`step-connector ${index < currentStepIndex ? 'completed' : ''}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default DealProgressIndicator;